import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const QuickActionCard = ({ action }) => {
  const navigate = useNavigate();

  const colorClasses = {
    primary: 'bg-primary/10 text-primary hover:bg-primary/20',
    secondary: 'bg-secondary/10 text-secondary hover:bg-secondary/20',
    accent: 'bg-accent/10 text-accent hover:bg-accent/20',
    success: 'bg-success/10 text-success hover:bg-success/20'
  };

  return (
    <button
      onClick={() => navigate(action?.path)}
      className={`w-full p-4 rounded-lg transition-smooth text-left ${colorClasses?.[action?.color]}`}
    >
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 bg-card rounded-lg flex items-center justify-center flex-shrink-0">
          <Icon name={action?.icon} size={20} />
        </div>
        <div className="flex-1 min-w-0">
          <h4 className="text-sm font-semibold mb-1">{action?.title}</h4>
          <p className="text-xs opacity-80">{action?.description}</p>
        </div>
        <Icon name="ArrowRight" size={16} className="flex-shrink-0 mt-1" />
      </div>
    </button>
  );
};

export default QuickActionCard;